const activeEventsList = {
  bindings: {
    selection: '<',
    settings: '<',
    criteria: '<',
    filters: '<',
    area: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/active-events-list/active-events-list.html',
  controller: 'ActiveEventsListController',
};

angular
  .module('gridlets.module')
  .component('activeEventsList', activeEventsList);